import { useState } from 'react'
import { Button } from 'react-bootstrap'
import DeleteRecordModal, { RecordType } from '@/components/shared/DeleteRecordModal'
import IconWithTooltip from '@/components/shared/IconWithTooltip'
import { useDeleteRecordMutation } from '@/features/apiSlice'

interface Props {
  recordType: RecordType
  recordIdOrSlug: string | number
  onDeleted?: () => void
  iconButton?: boolean
}

export function DeleteRecordButton({
  recordType,
  recordIdOrSlug,
  onDeleted,
  iconButton = false,
}: Props) {
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteRecord, { isLoading }] = useDeleteRecordMutation()

  const handleDelete = async () => {
    try {
      deleteRecord({ recordIdOrSlug, recordType })

      onDeleted?.()
      setShowDeleteModal(false)
    } catch (error) {
      console.error('Failed to delete record:', error)
    }
  }

  return (
    <>
      <Button
        variant={iconButton ? 'link' : 'danger'}
        size="sm"
        className={iconButton ? 'm-0 p-0' : undefined}
        onClick={() => setShowDeleteModal(true)}
        disabled={isLoading}
      >
        {iconButton
         ? isLoading
           ? <IconWithTooltip
             icon="fa-solid fa-spinner fa-spin small"
             tooltip={`Delete ${recordType}`}
             iconSize="sm" />
           : <IconWithTooltip
             icon="fa-solid fa-trash small"
             tooltip={`Delete ${recordType}`}
             iconSize="sm" />
         :
         'Delete'
        }
      </Button>
      <DeleteRecordModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onCancel={() => setShowDeleteModal(false)}
        onDelete={handleDelete}
        isDeleting={isLoading}
        recordType={recordType}
      />
    </>
  )
}
